import React from 'react';

type ClassGroup = {
    leading?: string;
    h1?: string;
    description?: string;
}

type SectionHeaderProps = {
    classWrapper?: string;
    classGroup?: ClassGroup;
    alignment?: string;
    leading?: string;
    title: string;
    description?: string;
    headingId?: string;
}

const SectionHeader = ({
    classWrapper,
    classGroup,
    alignment,
    leading,
    title,
    description,
    headingId
}: SectionHeaderProps) => {

    const hasContent = (content: string | undefined): boolean => content !== undefined && content.trim() !== '' && content !== 'undefined';


    if (hasContent(leading) || hasContent(title) || hasContent(description)) {
        const alignmentOptions = {
            isCentered: alignment === 'center',
            isRight: alignment === 'right',
            classes: alignment === 'center'
                ? 'mx-auto text-center'
                : alignment === 'right'
                    ? 'max-md:mx-auto max-md:text-center md:ml-auto md:text-right'
                    : 'text-center md:text-left'
        };

        return (
            <div className={`flex flex-col max-w-2xl lg:max-w-xl ${classWrapper} ${alignmentOptions.classes}`}>
                {
                    leading && leading !== 'undefined' && <span className={`${alignmentOptions.isCentered ? 'self-center' : alignmentOptions.isRight ? 'self-center md:self-end' : 'self-center md:self-start'} font-semibold rounded-full py-1 px-4 mb-4 text-xs uppercase border-2 bg-black border-neutral-900 
                 text-purple-400 ${classGroup?.leading}`}>{leading}</span>
                }
                {
                    title && title !== 'undefined' && <h1 id={headingId} className={`font-black mb-4 ${classGroup?.h1}`}>{title}</h1>
                }
                {
                    description && description !== 'undefined' && <p className={`text-lg text-[var(--headline-2-color)] ${classGroup?.description}`}>{description}</p>
                }
            </div>
        );
    }

    return null;
};

export default SectionHeader;
